/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloEtapas from 'Infotrack@Modelos/smartStock/etapas';
import IEtapas from 'Infotrack@Modelos/smartStock/etapas/entidades/etapas';

export default class ControladorModeloEtapas {
    private modeloEtapas: ModeloEtapas;
    constructor() {
        this.modeloEtapas = new ModeloEtapas();
    }

    public consultarEtapas() {
        return this.modeloEtapas.consultarEtapas().then(({ data: { Entidades } }) => Entidades);
    }

    public async ConsultarListaEtapasPorFiltro(EmpresaId: string, Estado?: number) {
        return this.modeloEtapas.ConsultarListaEtapasPorFiltro({ EmpresaId: EmpresaId , Estado: Estado}).then(({ data: { Entidades } }) => Entidades);
    }

    public async crearEtapas(etapas: IEtapas) {
        await this.modeloEtapas.crearEtapas(etapas);
    }

    public async editarEtapas(etapas: IEtapas) {
        await this.modeloEtapas.editarEtapas(etapas);
    }
    public async eliminarEtapas(etapas: IEtapas) {
        await this.modeloEtapas.eliminarEtapas(etapas);
    }

    public validarEntidad(etapas: IEtapas): boolean {
        if (etapas.EtapaDescripcion === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
